import ArticleTemplate from "../components/ArticleTemplate";
import { articles } from "@/mocks/articles";

export default function ArticleCoToJest() {
  return <ArticleTemplate article={articles[0]} />;
}